<!--
  ~ Copyright ou © ou Copr. Université de Lorraine, (2022)
  ~
  ~ Direction du Numérique de l'Université de Lorraine - SIED
  ~  (dn-mobile-dev@univ-lorraine.fr)
  ~ JNESIS (contact@jnesis.com)
  ~
  ~ Ce logiciel est un programme informatique servant à rendre accessible
  ~ sur mobile divers services universitaires aux étudiants et aux personnels
  ~ de l'université.
  ~
  ~ Ce logiciel est régi par la licence CeCILL 2.1, soumise au droit français
  ~ et respectant les principes de diffusion des logiciels libres. Vous pouvez
  ~ utiliser, modifier et/ou redistribuer ce programme sous les conditions
  ~ de la licence CeCILL telle que diffusée par le CEA, le CNRS et INRIA
  ~ sur le site "http://cecill.info".
  ~
  ~ En contrepartie de l'accessibilité au code source et des droits de copie,
  ~ de modification et de redistribution accordés par cette licence, il n'est
  ~ offert aux utilisateurs qu'une garantie limitée. Pour les mêmes raisons,
  ~ seule une responsabilité restreinte pèse sur l'auteur du programme, le
  ~ titulaire des droits patrimoniaux et les concédants successifs.
  ~
  ~ À cet égard, l'attention de l'utilisateur est attirée sur les risques
  ~ associés au chargement, à l'utilisation, à la modification et/ou au
  ~ développement et à la reproduction du logiciel par l'utilisateur étant
  ~ donné sa spécificité de logiciel libre, qui peut le rendre complexe à
  ~ manipuler et qui le réserve donc à des développeurs et des professionnels
  ~ avertis possédant des connaissances informatiques approfondies. Les
  ~ utilisateurs sont donc invités à charger et à tester l'adéquation du
  ~ logiciel à leurs besoins dans des conditions permettant d'assurer la
  ~ sécurité de leurs systèmes et/ou de leurs données et, plus généralement,
  ~ à l'utiliser et à l'exploiter dans les mêmes conditions de sécurité.
  ~
  ~ Le fait que vous puissiez accéder à cet en-tête signifie que vous avez
  ~ pris connaissance de la licence CeCILL 2.1, et que vous en avez accepté les
  ~ termes.
  -->

<app-header>

  <ion-buttons slot="end">
    <ion-button (click)="presentPopover($event)" [attr.aria-label]="'NOTIFICATIONS.FILTERS' | translate"
                class="ion-no-padding" fill="clear">
      <ion-icon aria-label="" name="filter-outline"></ion-icon>
    </ion-button>

    <ion-button [attr.aria-label]="'NOTIFICATIONS.SETTINGS.TITLE' | translate" fill="clear"
                routerLink="/notifications/settings">
      <ion-icon aria-label="" name="settings-outline"></ion-icon>
    </ion-button>
  </ion-buttons>

  <ion-popover #popover [isOpen]="isOpen" (didDismiss)="isOpen = false">
    <ng-template>
      <ion-list class="filter-list">
        <ion-row class="ion-justify-content-center">
          <ion-text class="app-title-5">{{ "NOTIFICATIONS.FILTERS" | translate }}</ion-text>
        </ion-row>
        <form [formGroup]="form" *ngIf="(filterableChannels$ | async) as filterableChannels">
          <ion-item class="channel-list" formArrayName="channelsForm"
            *ngFor="let channel of channelsForm.controls; let i = index">
            <ion-checkbox mode="md" [formControlName]="i">
              <ion-label class="app-text-3 light ion-text-wrap" for="terms">{{filterableChannels[i].label}}</ion-label>
            </ion-checkbox>
          </ion-item>
        </form>
      </ion-list>
    </ng-template>
  </ion-popover>

</app-header>

<ng-container *ngIf="channelsSelected$ | async as channelsSelected">
  <ion-list *ngIf="channelsSelected.length > 0" class="chip-list">
    <button (click)="removeChannelFromFilter(channel.code)" *ngFor="let channel of channelsSelected"
            [attr.aria-label]="'NOTIFICATIONS.REMOVE_FROM_FILTERS' | translate: {channel: channel.label}"
            class="chip-item">
      <ion-chip>
        {{ channel.label }}
        <ion-icon aria-label="" name="close-circle-outline"></ion-icon>
      </ion-chip>
    </button>
  </ion-list>
</ng-container>

<ion-content *ngIf="(filteredNotifications$ | async) as filteredNotifications">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-progress-bar *ngIf="isLoading" type="indeterminate"></ion-progress-bar>

  <ng-container *ngIf="filteredNotifications.length > 0">
    <ion-list class="notifications-list">
      <ion-item-sliding class="ion-margin-bottom notification-container"
        *ngFor="let notification of filteredNotifications">

        <div *ngIf="notification.color" class="notifications-color-bar"
          [ngStyle]="{'background-color': notification.color}"></div>

        <ion-item class="notifications" [ngClass]="{'notifications-unread': notification.state === 'UNREAD'}">
          <ion-col class="notifications-col">
            <ion-row>

              <ion-col class="ion-padding-bottom ion-padding-top">
                <ion-grid class="ion-no-padding ion-margin-bottom">
                  <ion-row>
                    <ion-col size="2" size-sm="1" class="ion-justify-content-center">
                      <ion-row class="icon-row ion-text-center ion-align-items-center">
                        <ion-icon aria-label="" class="app-icon-2" [name]="notification.icon"></ion-icon>
                      </ion-row>
                    </ion-col>
                    <ion-col size="9" size-sm="10">
                      <ion-label>
                        <h2 class="app-text-3 ion-text-wrap">{{notification.title}}</h2>
                        <p class="app-text-4 light ion-text-wrap">{{notification.creationDate | relativeTime}}</p>
                      </ion-label>
                    </ion-col>
                    <ion-col size="1" class="ion-align-items-end">
                      <button (click)="openModal(notification.id)"
                              [attr.aria-label]="'NOTIFICATIONS.OPEN_MENU' | translate">
                        <ion-icon aria-label="" class="ellipsis app-icon-3" name="ellipsis-horizontal"></ion-icon>
                      </button>
                    </ion-col>
                  </ion-row>
                </ion-grid>

                <ion-row>
                  <ion-text class="app-text-4 light">{{notification.message}}</ion-text>
                </ion-row>

                <ion-row class="ion-justify-content-end" *ngIf="notification.url">
                  <ion-button class="app-text-button-2 link-button" (click)="onClickLink(notification)" fill="clear">
                    <ion-text class="app-text-5">{{ "NOTIFICATIONS.LEARN_MORE" | translate }}</ion-text>
                    <ion-icon aria-label="" class="app-icon-6" name="arrow-right"></ion-icon>
                  </ion-button>
                </ion-row>

              </ion-col>

            </ion-row>
            <ion-row>
              <ion-col class="routerlink-col ion-justify-content-end">
                <ion-button *ngIf="notification.routerLink"
                            [attr.aria-label]="'NOTIFICATIONS.NAVIGATE_APP_PAGE' | translate"
                            [routerLink]="notification.routerLink"
                            class="routerlink-button ion-no-padding ion-no-margin" fill="clear" size="large">
                  <ion-icon aria-label="" name="arrow-forward-circle-outline"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-item>
        <ion-item-options>
          <ion-item-option (click)="deleteNotification(notification.id)" class="notifications-option">
            <ion-icon aria-label="" class="app-icon-3" name="trash"></ion-icon>
            <ion-label class="ion-text-uppercase">
              <h2 class="app-title-5">{{ "NOTIFICATIONS.DELETE" | translate }}</h2>
            </ion-label>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </ion-list>
    <ion-row class="ion-padding ion-justify-content-center">
      <ion-button class="app-rectangle-button-1" *ngIf="!hasScrollbar && !this.endOfNotifications" (click)="onIonInfinite($event)">
        <ion-label>{{"NOTIFICATIONS.LOAD_MORE" | translate }}</ion-label>
      </ion-button>
    </ion-row>

    <ion-modal #modal [isOpen]="isNotificationOptionsOpen" [initialBreakpoint]="0.5" [breakpoints]="[0, 0.5, 0.75, 1]"
      (willDismiss)="dismissModal()">
      <ng-template>
        <ion-header>
          <ion-toolbar>
            <ion-buttons slot="end">
              <ion-button (click)="dismissModal()">
                <ion-text class="app-title-6">
                  {{ 'NOTIFICATIONS.CLOSE' | translate }}</ion-text>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ng-container *ngIf="selectedNotificationOption">
          <ion-content class="ion-padding">
            <app-notification-options [notification]="selectedNotificationOption"
              (closeModal)="dismissModal()"></app-notification-options>
          </ion-content>
        </ng-container>
      </ng-template>
    </ion-modal>

    <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
      <ion-infinite-scroll-content>
        <ng-container *ngIf="endOfNotifications">
          <ion-note class="ion-text-center">
            {{ "NOTIFICATIONS.END_OF_NOTIFICATIONS" | translate }}
          </ion-note>
        </ng-container>
        <ng-container *ngIf="loadMoreNotificationsError">
          <ion-note class="ion-text-center danger">
            {{ "NOTIFICATIONS.LOAD_MORE_ERROR" | translate }}
          </ion-note>
        </ng-container>
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ng-container>

  <ng-container *ngIf="filteredNotifications.length === 0">
    <ion-row lines="none" class="ion-margin ion-justify-content-center">
      <ion-text>{{ "NOTIFICATIONS.NO_DATA" | translate }}</ion-text>
    </ion-row>
  </ng-container>
</ion-content>
